<div class="main">
  <button (click)="print()"
          class="float green" mat-fab>
    <mat-icon>print</mat-icon>
  </button>
  <div class="header">
    <button [routerLink]="['/admin']" mat-icon-button>
      <mat-icon>keyboard_backspace</mat-icon>
    </button>
    <h2>Privatlån detaljer</h2>
    <div class="spb-filler"></div>
  </div>
  @if (application$ | async; as application) {
    <div>
      <div class="wrapper">
        <div class="codes">
          <mat-accordion class="expansion-header">
            @for (code of application.codes; track i; let i = $index) {
              <mat-expansion-panel (opened)="currentItem = i"
                                   class="panel"
                                   hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title
                    [class]="{'bad-code' : !code.pass }"
                    class="code-title"
                  >{{ code.title }}
                  </mat-panel-title>
                  <mat-panel-description class="expansion-description">
                    <spb-indicator [codeList]="[code]"/>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div>
                  @for (value of code.values; track i; let i = $index) {
                    <div
                      class="stepper-item">
                      <div class="stepper-value">
                        @if (code.name === eventCodes.propertyLoanDiff || code.name === eventCodes.blancoLoanDiff) {
                          @if (i === 0) {
                            <div>Uppgivet:</div>
                          }
                          @if (i === 1) {
                            <div>UC:</div>
                          }
                          @if (i === 2) {
                            <div>Diff:</div>
                          }
                          <ng-container
                            *ngTemplateOutlet="listValue"></ng-container>
                        } @else {
                          @if (code.name === eventCodes.incomeDiff) {
                            <div>Diff:</div>
                          }
                          @if (code.name !== eventCodes.incomeDiff) {
                            <div>Info:</div>
                          }
                          <ng-container
                            *ngTemplateOutlet="listValue"></ng-container>
                        }
                      </div>
                      <!-- Templates for the status accordion -->
                      <ng-template #listValue>
                        @if (isNumber(value) && value >= 1 || value < 0) {
                          <div
                          >{{ value | number:'1.0-2':'sv' }}
                          </div>
                        }
                        @if (isNumber(value) && value < 1 && value > 0) {
                          <div
                          >{{ value * 100 | number:'1.0-2':'sv' }}
                            %
                          </div>
                        }
                        @if (!isNumber(value)) {
                          <div>{{ value }}</div>
                        }
                      </ng-template>
                    </div>
                  }
                  <div class="stepper-value">
                    <div>Datum:</div>
                    <div>{{ code.timeStamp | date:'yyyy-MM-dd' }}</div>
                  </div>
                  <div class="stepper-value small">
                    <div>Klockslag:</div>
                    <div>{{ code.timeStamp | date:'HH:mm:ss' }}</div>
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
        <div class="content">
          <div class="action-holder">
            <mat-form-field class="action-select" subscriptSizing="dynamic">
              <mat-label>Välj åtgärd</mat-label>
              <mat-select [formControl]="actionControl">
                @for (action of actions; track action.value) {
                  <mat-option [value]="action.value">
                    {{ action.title }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button
              (click)="doAction()"
              [disabled]="!actionControl.value" matButton="filled">Spara
            </button>
            @if (actionControl.dirty) {
              <button (click)="actionControl.reset()"
                      matButton="text">Ångra
              </button>
            }
            <div [style.flex-grow]="1"></div>
            <button
              (click)="delegate()"
              matButton="outlined">{{ application.adminData.assignee || 'Tilldela' }}
            </button>
          </div>
          <mat-card>
            <mat-card-content>
              <mat-card-title>Översikt</mat-card-title>
              <ng-container *ngTemplateOutlet="overview"></ng-container>
            </mat-card-content>
          </mat-card>
          @if (application.codes[currentItem].name === eventCodes.kalp) {
            <mat-card>
              <mat-card-content>
                <mat-card-title>
                  KALP {{ application.kalpResult.kalp | number:'1.0-0':'sv' }}
                </mat-card-title>
                <ng-container *ngTemplateOutlet="kalp"></ng-container>
              </mat-card-content>
            </mat-card>
            <mat-card>
              <mat-card-content>
                <mat-card-title>KALP-summering</mat-card-title>
                <ng-container *ngTemplateOutlet="kalpSummary"></ng-container>
              </mat-card-content>
            </mat-card>
          }
          @if (application.codes[currentItem].name === eventCodes.uc) {
            <mat-card>
              <mat-card-content>
                <mat-card-title>Upplysningscentralen</mat-card-title>
                <ng-container *ngTemplateOutlet="uc"></ng-container>
                <div class="uc-report">
                  <h2>UC Rapporter i HTML</h2>
                  <mat-tab-group>
                    @for (
                      applicant of application.applicants; track applicant.personNummer) {
                      <mat-tab
                        [label]="applicant.personNummer">
                        <spb-ucreport
                          [personnummer]="applicant.personNummer"/>
                      </mat-tab>
                    }
                  </mat-tab-group>
                </div>
              </mat-card-content>
            </mat-card>
          }
          @if (application.codes[currentItem].name === eventCodes.signed) {
            <mat-card>
              <mat-card-content>
                <mat-card-title>Signering</mat-card-title>
                <ng-container *ngTemplateOutlet="sign"></ng-container>
              </mat-card-content>
            </mat-card>
          }
          @if (application.codes[currentItem].name === eventCodes.incomeDiff) {
            <mat-card>
              <mat-card-content>
                <mat-card-title>Inkomstuppgifter</mat-card-title>
                <ng-container *ngTemplateOutlet="income"></ng-container>
              </mat-card-content>
            </mat-card>
          }
          @if (application.codes[currentItem].name === eventCodes.incomeReview) {
            <mat-card>
              <mat-card-content>
                <mat-card-title>Inkomstkontroll</mat-card-title>
                <ng-container *ngTemplateOutlet="incomeCheck"></ng-container>
              </mat-card-content>
            </mat-card>
          }
        </div>
      </div>
      <ng-container>
        <div class="print">
          <h3>Översikt</h3>
          <ng-container *ngTemplateOutlet="overview"></ng-container>
          <h3>Kreditupplysning</h3>
          <ng-container *ngTemplateOutlet="uc"></ng-container>
          <h3>Kvar att leva på</h3>
          <ng-container *ngTemplateOutlet="kalp"></ng-container>
          <ng-container *ngTemplateOutlet="kalpSummary"></ng-container>
          <h3>Signering</h3>
          <ng-container *ngTemplateOutlet="sign"></ng-container>
        </div>
      </ng-container>
      <ng-template #overview>
        <div class="card-column">
          @for (
            applicant of application.applicants; track applicant.personNummer; let
            i = $index) {
            <div>
              <div class="card-item">
                <h5>
                  @if (i < 1) {
                    <span>Sökande</span>
                  }
                  @if (i > 0) {
                    <span>Medsökande</span>
                  }
                </h5>
                <p>{{ applicant.name }}</p>
              </div>
              <div class="card-item">
                <h5>Personnummer</h5>
                <p>{{ applicant.personNummer }}</p>
              </div>
              <div class="card-item">
                <h5>Telefon</h5>
                <p>{{ applicant.phone }}</p>
              </div>
              <div class="card-item">
                <h5>E-post</h5>
                <p>{{ applicant.email }}</p>
                <div [style.margin-top.px]="15">
                  @if (applicant.employer) {
                    <p>
                      Arbetsgivare: {{ applicant.employer }}</p>
                  }
                  <p>
                    A-Kassa: {{ applicant.akassa ? 'Ja' : 'Nej' }}</p>
                  @if (applicant.spouse) {
                    <p>
                      Partner/make/maka: {{ applicant.spouse }}</p>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        <div [style.margin-bottom.px]="12">
          <p [style.margin]="0">Gått i borgen för någon annans
            lån: {{ application.loans.coSignedLoan ? 'Ja' : 'Nej' }}</p>
          <p [style.margin]="0">Har ytterligare kostnader att ta hänsyn
            till: {{ application.loans.additionalCosts ? 'Ja' : 'Nej' }}</p>
        </div>

        @if (application.houseHold && application.houseHold.applicantsAreSpouses) {
          <p
          >
            Medsökande/sökande är partner/sambo</p>
        }
        <div class="card-column">
          <div class="card-item">
            <h5>Datum</h5>
            <p>{{ application.timeStamp | date:'yyyy-MM-dd' }} {{ application.timeStamp | date:'HH:mm' }}</p>
          </div>
          <div class="card-item">
            <h5>Summa</h5>
            <p>{{ application.loan.amount | number:'1.0-0':'sv' }} kr</p>
          </div>
          <div class="card-item">
            <h5>Löptid</h5>
            <p>{{ application.loan.duration }} år</p>
          </div>
          <div class="card-item">
            <h5>Ränta</h5>
            @if (application.offer.interest) {
              <p
              >{{ application.offer.interest * 100 | number:'1.2-2':'sv' }}
                %</p>
            }
            @if (!application.offer.interest) {
              <p>Ej beräknad</p>
            }
          </div>
          <div class="card-item">
            <h5>Gallras</h5>
            <p>{{ application.gdprRemove ? (application.gdprRemove * 1000 | date:'yyyy-MM-dd') : '-' }} </p>
          </div>
        </div>
        <div class="card-column">
          <div class="card-item">
            <h5>Syfte</h5>
            @for (purpose of application.loan.purposes; track purpose) {
              <p>{{ purpose }}</p>
            }
          </div>
        </div>
      </ng-template>
      <ng-template #uc>
        <div class="card-column">
          @for (uc of application.ucResult; track i; let i = $index) {
            <div
              class="card-item">
              <div class="card-item">
                @if (i === 0) {
                  <h5>Sökande</h5>
                }
                @if (i === 1) {
                  <h5>Medsökande</h5>
                }
                <p>{{ uc.applicantName }}</p>
              </div>
              <div class="card-item">
                <h5>Inkomst</h5>
                <p>
                  @for (income of uc.income; track $index; let isLast = $last) {
                    <span>
                      {{ income }} kr@if (!isLast) {
                      <span>, </span>
                    }
                  </span>
                  }
                </p>
              </div>
              <div class="card-column">
                <div class="card-item">
                  <h5>Länskod</h5>
                  <p>{{ uc.countyCode }}</p>
                </div>
                <div class="card-item">
                  <h5>Kommunkod</h5>
                  <p>{{ uc.municipalityCode }}</p>
                </div>
                <div class="card-item">
                  <h5>Församlingskod</h5>
                  <p>{{ uc.parishCode }}</p>
                </div>
              </div>
              <div class="card-item">
                <h5>Beslut</h5>
                <p>{{ uc.decision }}</p>
              </div>
              <div class="card-item">
                <h5>Orsak</h5>
                @for (reason of uc.reasons; track reason) {
                  <p>{{ reason }}</p>
                }
              </div>
              <div class="card-item">
                <h5>UC Risk</h5>
                <p>{{ uc.ucRisk }}</p>
              </div>
              <div class="card-item">
                <h5>Status</h5>
                <p>{{ uc.status }}</p>
              </div>
            </div>
          }
        </div>
      </ng-template>
      <ng-template #sign>
        @for (code of application.codes; track i; let i = $index) {
          <div>
            @if (code.name === eventCodes.signed) {
              <div>
                <div class="card-column">
                  <div class="card-item">
                    <h5>Datum</h5>
                    <p>{{ code.timeStamp | date:'yyyy-MM-dd' }}</p>
                  </div>
                  <div class="card-item">
                    <h5>Klockan</h5>
                    <p>{{ code.timeStamp | date:'HH:mm:ss' }}</p>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </ng-template>
      <ng-template #income>
        @for (code of application.codes; track i; let i = $index) {
          <div>
            @if (code.name === eventCodes.incomeDiff) {
              <div>
                @for (
                  applicant of application.applicants; track applicant.personNummer; let
                  i = $index) {
                  <div
                    class="card-column">
                    <div class="card-item">
                      <h5>Uppgivet</h5>
                      <p>{{ applicant.income * 12 | number:'1.0-0':'sv' }}</p>
                    </div>
                    <div class="card-item">
                      <h5>UC</h5>
                      <p>{{ application.ucResult![i].income[0] | number:'1.0-0':'sv' }}</p>
                    </div>
                    <div class="card-item">
                      <h5>Diff</h5>
                      <p>{{ (((applicant.income * 12) / +application.ucResult![i].income[0]) - 1) * 100 | number:'1.2-2':'sv' }}
                        %</p>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </ng-template>
      <ng-template #kalp>
        <div>
          <p>Skuldkvot</p>
          <div class="card-column">
            <div class="card-item">
              <h5>Skuldkvot</h5>
              <p>{{ application.kalpResult.houseHold.debtQuota.quota! * 100 | number:'1.0-0':'sv' }}</p>
            </div>
            <div class="card-item">
              <h5>Bolån</h5>
              <p>{{ application.kalpResult.houseHold.debtQuota.mortgage | number:'1.0-0':'sv' }}
                kr</p>
            </div>
            <div class="card-item">
              <h5>Inkomster</h5>
              <p>{{ application.kalpResult.houseHold.debtQuota.income | number:'1.0-0':'sv' }}
                kr</p>
            </div>
            <div class="card-item">
              <h5>Barnbidrag</h5>
              <p>{{ application.kalpResult.houseHold.debtQuota.childrenBenefit | number:'1.0-0':'sv' }}
                kr</p>
            </div>
            <div class="card-item">
              <h5>Total inkomst</h5>
              <p>{{ application.kalpResult.houseHold.debtQuota.totalIncome | number:'1.0-0':'sv' }}
                kr</p>
            </div>
            <div class="card-item">
              <h5>Extra amortering (bolån)</h5>
              <p>{{ application.kalpResult.houseHold.additionalRepayment * 100 | number:'1.0-0':'sv' }}</p>
            </div>
          </div>
          @if (application.houseHold && application.houseHold.children
          && application.houseHold.children.length > 0) {
            <div
            >
              <h4>Barn</h4>
              <div class="card-column">
                <div class="card-item">
                  <h5>Antal</h5>
                  <p>{{ application.kalpResult.houseHold.children.childrenCount }}</p>
                </div>
                <div class="card-item">
                  <h5>Barnbidrag</h5>
                  <p>{{ application.kalpResult.houseHold.children.childrenBenefit | number:'1.0-0':'sv' }}</p>
                </div>
                <div class="card-item">
                  <h5>Flerbarnstillägg</h5>
                  <p>{{ application.kalpResult.houseHold.children.childrenBenefitExtra | number:'1.0-0':'sv' }}</p>
                </div>
                <div class="card-item">
                  <h5>Kostnad</h5>
                  <p>{{ application.kalpResult.houseHold.children.childrenCost | number:'1.0-0':'sv' }}</p>
                </div>
                <div class="card-item">
                  <h5>Netto</h5>
                  <p>{{ application.kalpResult.houseHold.children.childrenNetCost| number:'1.0-0':'sv' }}</p>
                </div>
              </div>
              @if (application.houseHold.children.length > 0) {
                <div
                  [style.display]="'flex'">
                  @for (child of application.houseHold.children; track i; let
                    i = $index) {
                    <div
                      [style.margin-right.px]="25"
                      class="card-item">
                      <h5>Barn {{ i + 1 }}</h5>
                      Ålder:   {{ child.age | number: '1.0-0' }} år<br>
                      Kostnad: {{ child.monthlyCost }} kr
                    </div>
                  }
                </div>
              }
              @if (application.loans.monthlyChildcareCost) {
                <p>Kostnad för
                  barnomsorg: {{ application.loans.monthlyChildcareCost }}
                  kr</p>
              }
            </div>
          }
          <h4>Boende</h4>
          @for (living of application.living; track idx; let idx = $index) {
            <div>
              <div class="card-column">
                <div class="card-item">
                  <h5>Bor @if (idx === 1) {
                    <span>också </span>
                  } i: </h5>
                  <p>{{ LIVINGS[living.type] }}</p>
                </div>
                @if (living.loan) {
                  <div class="card-item">
                    <h5>Lån</h5>
                    <p>{{ living.loan| number:'1.0-0':'sv' }} kr</p>
                  </div>
                }
                @if (living.rent) {
                  <div class="card-item">
                    <h5>Hyra</h5>
                    <p>{{ living.rent| number:'1.0-0':'sv' }} kr/mån</p>
                  </div>
                }
                @if (living.fee) {
                  <div class="card-item">
                    <h5>Avgift</h5>
                    <p>{{ living.fee| number:'1.0-0':'sv' }} kr/mån</p>
                  </div>
                }
                <div class="card-item">
                  <h5>Driftskostnad</h5>
                  <p>{{ living.operationCost | number:'1.0-0':'sv' }} kr/mån</p>
                </div>
                <div class="card-item">
                  <h5>Fastighetsavgift</h5>
                  <p>{{ living.propertyFee| number:'1.0-0':'sv' }} kr/mån</p>
                </div>
              </div>
            </div>
          }
          <h4>Studielån</h4>
          <div class="card-item">
            <h5>Belopp</h5>
            <p>{{ application.kalpResult.houseHold.studyLoan| number:'1.0-0':'sv' }}
              kr/mån</p>
          </div>
        </div>
        @if (application.kalpResult.houseHold.cars) {
          <div>
            <h4>{{ application.kalpResult.houseHold.cars.length === 1 ? 'Bil' : 'Bilar' }}</h4>
            <div class="card-column">
              <div class="card-item">
                <h5>Antal</h5>
                <p>{{ application.kalpResult.houseHold.cars.length }}</p>
              </div>
              <div class="card-item">
                <h5>Kostnad</h5>
                <p>{{ application.kalpResult.monthlyCarCost | number:'1.0-0':'sv' }}
                  kr/mån</p>
              </div>
            </div>
          </div>
        }
        <h4>Sökande</h4>
        <div class="card-column">
          @for (applicant of application.kalpResult.applicants; track i; let
            i = $index) {
            <div
              class="card-item">
              <div class="card-column">
                <div class="card-item">
                  @if (i === 0) {
                    <h5>Sökande</h5>
                  }
                  @if (i === 1) {
                    <h5>Medsökande</h5>
                  }
                  <p>{{ applicant.name }}</p>
                </div>
                <div class="card-item">
                  <h5>Sysselsättning</h5>
                  <p>{{ OCCUPATIONS[applicant.occupation] }}</p>
                </div>
                <div class="card-item">
                  <h5>Inkomst</h5>
                  <p>{{ applicant.income | number:'1.0-0':'sv' }}</p>
                </div>
              </div>
              <div class="card-column">
                <div class="card-item">
                  <h5>Skatt</h5>
                  <p>{{ applicant.tax | number:'1.0-0':'sv' }}</p>
                </div>
                <div class="card-item">
                  <h5>Tabell</h5>
                  <p>{{ applicant.taxValue | number:'1.0-0':'sv' }}</p>
                </div>
                <div class="card-item">
                  <h5>Kolumn</h5>
                  <p>{{ applicant.taxColumn | number:'1.0-0':'sv' }}</p>
                </div>
                <div class="card-item">
                  <h5>Skattereduktion</h5>
                  <p>{{ applicant.interestTaxReturnMonth | number:'1.0-0':'sv' }}</p>
                </div>
                <div class="card-item">
                  <h5>Levnadsomkostnad</h5>
                  <p>{{ applicant.livingExpense | number:'1.0-0':'sv' }}</p>
                </div>
              </div>
            </div>
          }
        </div>
        <h4>Lån</h4>
        <table [dataSource]="loanDataSource" mat-table>
          <caption></caption>
          <ng-container matColumnDef="type">
            <th *matHeaderCellDef id="type" mat-header-cell>Typ</th>
            <td *matCellDef="let loan" mat-cell>{{ loan.name }}</td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th *matHeaderCellDef class="right" id="amount" mat-header-cell>
              Belopp
            </th>
            <td *matCellDef="let loan" class="right"
                mat-cell>{{ loan.amount | number:'1.0-0':'sv' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="interest">
            <th *matHeaderCellDef class="right" id="interest" mat-header-cell>
              Ränta (%)
            </th>
            <td *matCellDef="let loan" class="right"
                mat-cell>{{ loan.interestPercent * 100| number:'1.2-2':'sv' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="interestMonth">
            <th *matHeaderCellDef class="right" id="interestMonth"
                mat-header-cell>Ränta (kr/mån)
            </th>
            <td *matCellDef="let loan" class="right"
                mat-cell>{{ loan.interestPerMonth | number:'1.0-0':'sv' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="repaymentMonth">
            <th *matHeaderCellDef class="right" id="repaymentMonth"
                mat-header-cell>Amortering (kr/mån)
            </th>
            <td *matCellDef="let loan" class="right"
                mat-cell>{{ loan.repaymentPerMonth | number:'1.0-0':'sv' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cost">
            <th *matHeaderCellDef class="right" id="cost" mat-header-cell>
              Månadskostnad (kr/mån)
            </th>
            <td *matCellDef="let loan" class="right"
                mat-cell>{{ loan.cost | number:'1.0-0':'sv' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="solve">
            <th *matHeaderCellDef class="right" id="solve" mat-header-cell>Löses
            </th>
            <td *matCellDef="let loan" class="right checkbox-fix" mat-cell>
              <mat-checkbox [checked]="loan.solve"
                            disabled="true"/>
            </td>
          </ng-container>
          <tr *matHeaderRowDef="loanColumnsToShow" mat-header-row></tr>
          <tr *matRowDef="let element; columns: loanColumnsToShow" mat-row>
        </table>
      </ng-template>
      <ng-template #kalpSummary>
        @for (item of application.kalpResult.calculation; track $index) {
          <div
            class="kalp-row">
            @if (item.type === 'h') {
              <div class="kalp-header">
                <p><strong>{{ item.text }}</strong></p>
              </div>
            }
            @if (item.type === '-' || item.type === '+') {
              <div class="kalp-item">
                <div>{{ item.text }}</div>
                <div>{{ item.type }} {{ item.sum | number:'1.0-0':'sv' }}</div>
              </div>
            }
            @if (item.type === '=') {
              <div class="kalp-sum">
                <div>{{ item.sum | number:'1.0-0':'sv' }}</div>
              </div>
            }
          </div>
        }
      </ng-template>
      <ng-template #incomeCheck>
        @for (code of application.codes; track i; let i = $index) {
          <div>
            @if (code.name === eventCodes.incomeReview) {
              <div>
                <div class="card-column">
                  <div class="card-item">
                    <h5>Datum</h5>
                    <p>{{ code.timeStamp | date:'yyyy-MM-dd' }}</p>
                  </div>
                  <div class="card-item">
                    <h5>Klockan</h5>
                    <p>{{ code.timeStamp | date:'HH:mm:ss' }}</p>
                  </div>
                  <div class="card-item">
                    <h5>Handläggare</h5>
                    <p>{{ code.values[0] }}</p>
                  </div>
                  <button (click)="removeCode(code)" class="card-item" matButton="outlined">
                    Ta bort
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </ng-template>
    </div>
  }
</div>